import { type BannersList } from '@cx-web/api-clients/banners-api/types';
import useMedia from '@cx-web/ui-shell/use-media';

import BannersCarouselDesktop from './components/BannersCarouselDesktop';
import BannersCarouselGrid from './components/BannersCarouselGrid';

export default function BannersCarousel({ banners, interval = 4000 }: { banners: BannersList; interval?: number }) {
  const { isDesktop } = useMedia();

  if (!banners) return null;

  const Component = isDesktop ? BannersCarouselDesktop : BannersCarouselGrid;

  return <Component banners={banners} interval={interval} />;
}
